import { render } from "./ShoppableModal.vue?vue&type=template&id=ce984dba"
import script from "./ShoppableModal.vue?vue&type=script&lang=js"
export * from "./ShoppableModal.vue?vue&type=script&lang=js"

import "./ShoppableModal.vue?vue&type=style&index=0&id=ce984dba&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__